module.exports = __webpack_public_path__ + "assets/media/death.a73e28f3.ogg";